<template>
  <div @click="handleClickInternal()" class="user-component">
    <!-- <h1>{{ msg }}: {{ data.data.time }} {{ numClicks }}</h1> -->
    <h1>{{ index + ' ' + msg }}: {{ data.data.time }} {{ numClicks }}</h1>
  </div>
</template>

<script>
export default {
  name: 'UserList',
  props: ['data', 'index'],
  data () {
    return {
      msg: 'User list',
      numClicks: 0
    }
  },
  methods: {
    handleClickInternal () {
      this.numClicks++
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
div.user-component{
  background-color: orange;
}
h1, h2 {
  font-weight: normal;
}
a {
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/UserList.vue